var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Star 3",
    d: "M5.00201 2.14919C5.63089 0.213685 8.36911 0.213686 8.99799 2.14919C9.27924 3.01477 10.0859 3.60081 10.996 3.60081C13.0311 3.60081 13.8772 6.20501 12.2308 7.40122C11.4945 7.93618 11.1864 8.88442 11.4676 9.75C12.0965 11.6855 9.88126 13.295 8.23483 12.0988C7.49852 11.5638 6.50148 11.5638 5.76517 12.0988C4.11874 13.295 1.90347 11.6855 2.53235 9.75C2.8136 8.88442 2.5055 7.93618 1.76919 7.40122C0.122753 6.20501 0.968909 3.60081 3.00402 3.60081C3.91414 3.60081 4.72076 3.01477 5.00201 2.14919Z",
    fill: "#D18030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar3);
export default __webpack_public_path__ + "static/media/Star 3.49db9e914076297245000cf1fd1f975f.svg";
export { ForwardRef as ReactComponent };